<div class="roles-change-dialog">
    <button type="button" class="close-button" aria-label="Dialog schließen" (click)="close()">
        ×
    </button>

    <header class="dialog-header">
        <h2>Rollen für {{ data.selectedUsers.length }} Benutzer ändern</h2>
        <p>Wähle eine Aktion und die gewünschten Rollen aus.</p>
    </header>

    <section class="action-section">
        <h3>Aktion</h3>

        <div class="custom-select" [class.open]="isActionDropdownOpen()">
            <button type="button" class="select-trigger" (click)="toggleActionDropdown()">
                <span>{{ currentAction().label }}</span>
                <mat-icon fontSet="material-icons-outlined">expand_more</mat-icon>
            </button>

            @if (isActionDropdownOpen()) {
            <div class="select-options">
                @for (option of actionOptions; track option.value) {
                <button type="button" class="select-option" [class.selected]="selectedAction() === option.value"
                    (click)="selectAction(option.value)">
                    {{ option.label }}
                </button>
                }
            </div>
            }
        </div>

        <p class="action-description">
            {{ currentAction().description }}
        </p>
    </section>

    <section class="roles-section">
        <h3>Rollen</h3>

        <div class="roles-list">
            @for (rolle of data.rollen; track rolle.id) {
            <button type="button" class="role-option" [class.selected]="isRoleSelected(rolle.name)"
                (click)="toggleRole(rolle.name)">
                <span class="fake-checkbox" [class.checked]="isRoleSelected(rolle.name)"></span>

                <span class="role-content">
                    <strong>{{ rolle.name }}</strong>

                    @if (rolle.istAdminRolle) {
                    <span class="admin-chip">
                        <mat-icon fontSet="material-icons-outlined">shield</mat-icon>
                        Admin
                    </span>
                    }
                </span>
            </button>
            }
        </div>
    </section>

    <section class="affected-users-box">
        <strong>Betroffene Benutzer:</strong>

        <div class="affected-users-list">
            @for (user of data.selectedUsers; track user.id) {
            <span>{{ user.benutzername }}</span>
            }
        </div>
    </section>

    <footer class="dialog-actions">
        <button type="button" class="cancel-button" (click)="close()">
            Abbrechen
        </button>

        <button type="button" class="save-button" (click)="submit()">
            Übernehmen
        </button>
    </footer>
</div>